export default "__VITE_ASSET__D7KV9TMT__"